import Vue from 'vue'
import App from './App.vue'
import router from '@/routers'
// import vuetify from './plugins/vuetify'
import vuetify from '@/plugins/vuetify'
import store from '@/store'
import { sync } from 'vuex-router-sync'
import Public from '@/layouts/public/Index.vue'
import Private from '@/layouts/private/Index.vue'
import i18n from '@/plugins/i18n'

Vue.config.productionTip = false
sync(store, router)

Vue.component('public-layout', Public)
Vue.component('private-layout', Private)

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (localStorage.getItem('jwt') == null) {
      next({
        path: '/login',
        params: { nextUrl: to.fullPath }
      })
    } else {
      next()
    }
  } else {
    next()
  }
})

new Vue({
  i18n,
  vuetify,
  router,
  store,
  render: h => h(App)
}).$mount('#app')
